import { useState } from 'react';
import { useUnderwritingRules } from '@services/underwritingRules';
import { useNewTask } from '@services/underwritingTasks';
import { useQuote } from '@services/quotes';
import { TextField } from '@components/textField';
import { Dialog } from '@components/dialog';
import { Box } from '@mui/material';

export const FlagForReferralDialog = ({
  open,
  handleClose,
  quoteId,
}: {
  open: boolean;
  quoteId: string;
  handleClose: () => void;
}) => {
  const { quote, isLoading: quoteIsLoading } = useQuote(quoteId);
  const { underwritingRule } = useUnderwritingRules({ offeringId: quote?.offering.id ?? '' });
  const { createNewTaskAsync, isPending: isLoading } = useNewTask(quoteId);
  const [notes, setNotes] = useState<string>('');

  const uwRule = underwritingRule?.items.find((el) => {
    return el.underwritingLabel === 'Other';
  });

  const handleSubmit = async () => {
    const issue = {
      underwritingRuleId: uwRule?.id || '',
      underwritingRuleDetail: `Flagged for referral: ${notes}`,
    };
    await createNewTaskAsync(issue);
    handleClose();
  };

  return quoteIsLoading ? null : (
    <Dialog
      handleCloseDialog={handleClose}
      isPrimaryBtnDisabled={!notes || !uwRule}
      isPrimaryBtnLoading={isLoading}
      open={open}
      primaryBtnAction={handleSubmit}
      primaryBtnText='Flag for Referral'
      secondaryBtnAction={handleClose}
      secondaryBtnText='Exit'
      size='small'
      title={`Flag Quote #${quote?.policyNumber?.policyNumber} for Referral`}
    >
      <Box sx={{ padding: '20px' }}>
        <TextField
          fullWidth
          inputLabel='Notes'
          value={notes}
          onChangeInput={(value) => setNotes(value)}
          multiline
          rows={4}
        />
      </Box>
    </Dialog>
  );
};
